import { render, staticRenderFns } from "./PageSticker.vue?vue&type=template&id=0cc9f420&"
import script from "./PageSticker.vue?vue&type=script&lang=js&"
export * from "./PageSticker.vue?vue&type=script&lang=js&"
import style0 from "./PageSticker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports